import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';

import * as actions from '../actions';

// TODO - make as prev-next component for all configurator
class PrevNext extends Component {

    render() {
        let flag = this.props.isValid;
        let className = "btn btn-flat";
        if(!flag){
            className += " btn-inactive";
        }
        return (
            <div className={`${this.props.divClass} prev-next`}>
                {this.props.currentStep > 1 ?
                    <button
                        onClick={() => { if(flag) this.props.stepControl('prev') }}
                        className={className}>
                        <i className='material-icons'>arrow_back</i>
                        { this.props.translate('previous') }
                    </button> :
                    null
                }
                {this.props.currentStep < this.props.lastStep ?
                    <button
                        onClick={() => { if(flag) this.props.stepControl('next') }}
                        className={className + ' right'}>
                        { this.props.translate('next') }
                        <i className='material-icons'>arrow_forward</i>
                    </button> :
                    null
                }
            </div>
        )
    }

}

/**
 * Prop types
 * @type {{tempDetails: *}}
 */
PrevNext.propTypes = {
    stepControl: PropTypes.func.isRequired,
    translate:   PropTypes.func.isRequired,
    divClass:    PropTypes.string,
    currentStep: PropTypes.number,
    lastStep:    PropTypes.number,
    isValid: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        translate:       getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        isValid: state.formInput.isFormValid,
    }
};

export default connect(mapStateToProps, actions)(PrevNext)




// WEBPACK FOOTER //
// ./src/components/PrevNext.js